// extracted by mini-css-extract-plugin
export default {"algoliaLogo":"SearchBox2_algoliaLogo__PF8ts"};